<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const imageSrc = cfgToThemeCdnPath("/about-vip/modern/level-up-progression.png");
const levelUpGlowPosition = $derived($isMobile ? "right" : "center");
const levelUpGlowTransform = $derived($isMobile ? "translate(85%, -50%)" : "");
const levelUpGlowSize = $derived($isMobile ? "90%" : "");
const levelUpGlowMinWidth = $derived($isMobile ? "750px" : "");
</script>

<section class="vip-level-up">
	<VipModernEyebrow text={$t(Verbiage.vip_modern_level_up)} />

	<Text
		type="title"
		titleSize="h4"
		titleWeight="bold"
		textColor="white"
		textAlign={$isMobile ? 'start' : 'center'}
		className="vip-level-up-title"
	>
		{$t(Verbiage.vip_modern_level_up_title)}
	</Text>

	<Text
		type="body"
		bodySize="large"
		textColor="gray"
		textAlign={$isMobile ? 'start' : 'center'}
		className="vip-level-up-body"
	>
		{$t(Verbiage.vip_modern_level_up_body)}
	</Text>

	<InfoCard
		modernStyle
		modernGlowPosition={levelUpGlowPosition}
		modernGlowTransform={levelUpGlowTransform}
		modernGlowSize={levelUpGlowSize}
		modernGlowMinWidth={levelUpGlowMinWidth}
		noPadding
		borderRadius="8px"
		customClass="vip-level-up-card"
	>
		<div class="vip-level-up-scroll">
			<img class="vip-level-up-img" src={imageSrc} alt={$t(Verbiage.illustration_alt, 'alts')} />
		</div>
	</InfoCard>
</section>

<style>
	.vip-level-up {
		margin-top: 1.5rem;
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: flex-start;
		gap: 1.25rem;
		text-align: left
}

	:global(.vip-level-up-title) {
		font-size: 32px !important
}

	:global(.vip-level-up-body) {
		max-width: 50rem
}

	:global(.vip-level-up-card) {
		margin-top: 1.5rem;
		min-height: 200px;
		width: 100%
}

	:global(.vip-level-up-card .info-card-modern) {
		min-height: 200px
}

	.vip-level-up-scroll {
		display: flex;
		min-height: 200px;
		width: 100%;
		align-items: center;
		overflow-x: auto;
		padding-left: 1.5rem;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: thin;
		scrollbar-color: var(--color-neutral-900) var(--color-background-900)
}

	.vip-level-up-scroll::-webkit-scrollbar {
		display: block;
		height: 0.5rem;
		background-color: transparent
}

	.vip-level-up-scroll::-webkit-scrollbar-track {
		background-color: var(--color-background-900)
}

	.vip-level-up-scroll::-webkit-scrollbar-thumb {
		border-radius: 0.5rem;
		background-color: var(--color-neutral-900)
}

	.vip-level-up-img {
		display: block;
		height: auto;
		width: 100%;
		min-width: 900px;
		flex-shrink: 0
}

	@media (min-width: 1024px) {
		.vip-level-up {
				align-items: center;
				text-align: center
		}

		:global(.vip-level-up-title) {
				font-size: 37px !important
		}

		:global(.vip-level-up-card .info-card-modern)::before {
				top: 50%;
				--tw-translate-x: -50%;
				--tw-translate-y: -50%;
				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
		}

		.vip-level-up-scroll {
				overflow-x: visible
		}

		.vip-level-up-img {
				min-width: 0px
		}
	}
</style>
